import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Customform from "../../../components/commonComponent/Customform.js";
import "../../../styles/Form.css";
import AWS from "../../../utils/awsConfig.js";
import { MODE } from "../../../constants/SiteConstants";

const API_URL = process.env.REACT_APP_API_URL;

const fields = [
  { label: "File", name: "file", placeholder: "Enter File Name", required: true },
  { label: "xmlData", name: "xmlData", placeholder: "add xmlData", required: true , type: "textarea",},
];

const AddBlob = () => {
  const navigate = useNavigate();
  const [imageFiles, setImageFiles] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);

  const handleImageUpload = async (file) => {
    const s3 = new AWS.S3();
    const params = {
      Bucket: "solar-station",
      Key: `${Date.now()}_${file.name}`,
      Body: file,
      ACL: "public-read",
    };

    try {
      const { Location } = await s3.upload(params).promise();
      return Location;
    } catch (error) {
      toast.error("Error uploading image: " + error.message);
      throw error;
    }
  };
  const handleSubmit = async (formData) => {
    try {
      if (imageFiles.length > 0) {
        const uploadedImageUrls = await Promise.all(
          imageFiles.map((file) => handleImageUpload(file))
        );
        formData.images = uploadedImageUrls;
      }
  
      const transformedData = {
        ...formData,
        blogcategory: formData.blogcategory?.map((item) => item.value) || [],
        productcategory: formData.productcategory?.map((item) => item.value) || [],
      };
  
      console.log("Transformed Data: ", transformedData);
  
      const response = await axios.post(`${API_URL}/sitemap/create`, transformedData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      if (response.status === 200 || response.status === 201) {
        toast.success("Data added successfully", {
          autoClose: 1000,
        });
        navigate("/sitemap");
      } else {
        throw new Error("Unexpected server response");
      }
    } catch (error) {
      console.error("Error adding data: ", error);
  
      const errorMessage =
        error.response?.data?.message || "Error adding data. Please try again.";
      toast.error(errorMessage, {
        autoClose: 1000,
      });
    }
  };
  
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      setImageFiles(files);
      const previews = files.map((file) => URL.createObjectURL(file));
      setImagePreviews(previews);
    }
  };

  console.log("imageFiles ", imageFiles, imagePreviews);

  return (
    <div className="form-wrapper shadow-md">
      <div className="form-header">
        <h3 className="font-medium text-black border-b border-gray-300 pb-2 w-full">
          Add Sitemap
        </h3>
        <button
          className="form-close-btn"
          onClick={() => navigate("/blogManagement")}
        >
          &times;
        </button>
      </div>
      <Customform
        mode={MODE.ADD}
        onSubmit={handleSubmit}
        fields={fields}
        imagePreview={imagePreviews}
        handleCustomerImageChange={handleImageChange}
      />
    </div>
  );
};

export default AddBlob;
